import { Component, computed, HostListener, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmPopupComponent, SpinnerService, ViewportHeightService } from '@zayan-erp/shared';
import { format } from 'date-fns';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';

@Component({
  imports: [RouterOutlet, ConfirmPopupComponent, LottieComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  spinnerService = inject(SpinnerService);
  isBlockedUIActive = computed(() => this.spinnerService.isSpinnerRunning());

  title = 'Login';
  currentDate = format(new Date(), 'yyyy-MM-dd');

  private resizeTimeout: any;

  constructor(private viewportHeightService: ViewportHeightService) {}

  ngOnInit(): void {
    // Set the dynamic height when the component initializes
    this.viewportHeightService.setDynamicHeight();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    // Clear the previous timeout
    clearTimeout(this.resizeTimeout);

    // Set a new timeout to call the resize handler after 200ms
    this.resizeTimeout = setTimeout(() => {
      this.viewportHeightService.setDynamicHeight();
    }, 210);
  }

  options: AnimationOptions = {
    path: 'assets/images/lottie-animations/loading.json'
  };
}
